const MODULE_NAME = 'campaign-benchmarking';

const permissions = 'CAMPAIGN_BENCHMARKING_UI_TA';

export { MODULE_NAME, permissions };
